export class reports{
    reportName:any
    category:any;
    subCategory:any;
    status:any;
    fromDate:any
    toDate:any;
    periodicType:any;
    pincode:any;
    span:any
}